import React, { useState } from 'react'
import { forgotPasswordStyles } from './style'
import {
  Box,
  TextField,
  Grid,
} from '@material-ui/core'
import { useFormik } from 'formik'
import { connect } from 'react-redux'
import { userSignUp } from '../../AppRedux/actions/Auth'
import * as yup from 'yup'
import DisplayMessage from '../../Components/DisplayMessage'
import service from '../../utils/service'
import Urls from '../../utils/urlStrings'
import { COMMON, MICROSERVICES } from '../../utils/constants'
import { AppButton } from '../../Components'
import _ from 'lodash'
import * as MESSAGETYPES from '../../utils/messageTypes'

const validationSchema = yup.object({
  email: yup
    .string('Enter your email')
    .email('Enter a valid email')
    .required('Email is required'),
})

function ForgotPassword(props) {
  const classes = forgotPasswordStyles()
  const [open, setOpen] = useState(false)
  const [message, setMessage] = useState('')
  const [messageType, setMessageType] = useState('info')

  const formik = useFormik({
    initialValues: {
      email: '',
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      service
        .post(
          Urls.getApiUrl(
            `admin/signup/forgotPassword`,
            MICROSERVICES.SESSIONMANAGER,
          ),
          null,
          {
            params: {
              email: values.email,
            },
          },
        )
        .then((messageData) => {
          setMessage(messageData.data.data)
          setMessageType('success')
          setOpen(true)
        })
        .catch((error) => {
          setOpen(true)
          setMessage(_.get(error, 'data.error.displayMessage', 'Failed to set password'))
          setMessageType(MESSAGETYPES.ERROR)
        })
    },
  })

  const handleClose = (event, reason) => {
    if (reason === COMMON.CLICKAWAY) {
      return
    }

    setOpen(false)
  }

  return (
    <>
      <div className={classes.ForgotPasswordDiv}>
        <DisplayMessage
          open={open}
          message={message}
          messageType={messageType}
          handleClose={handleClose}
        />
        <Box className={classes.ForgotPasswordBox}>
          <Box className={classes.ForgotPasswordTextBox}>
            <p>Forgot Password</p>
          </Box>
          <hr />
          <Box className={classes.container}>
            <p>
              Please enter your email ID below to receive the reset password
              link.
            </p>
            <form onSubmit={formik.handleSubmit}>
              <Box mb={4}>
                <Grid container spacing={4}>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      id="email"
                      name="email"
                      label="Email Id"
                      value={formik.values.email}
                      onChange={formik.handleChange}
                      error={
                        formik.touched.email && Boolean(formik.errors.email)
                      }
                      helperText={formik.touched.email && formik.errors.email}
                    />
                  </Grid>
                </Grid>
              </Box>
              <AppButton
                type="submit"
                text="Submit"
              />
            </form>
          </Box>
          <hr />
          <Box className={classes.container}>
            <p>Would you like to Sign In Instead?</p>
            <AppButton
              text="Sign In"
              fill={false}
              onClick={() => props.history.push('/signin')}
            />
          </Box>
        </Box>
      </div>
    </>
  )
}

const mapStateToProps = ({ auth }) => {
  const { message, loading } = auth
  return { message, loading }
}

const mapDispatchToProps = (dispatch) => ({
  userSignUp: (payload) => dispatch(userSignUp(payload)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword)
